import {
  getPromotionList,
  pathCreatePromotion,
  pathDeletePromotion,
  postImportPromotion,
} from "../constants/apiRoutes";

import apiService from "../utils/configAxios";
import { promotionActions } from "../reducers/promotion";
import { toast } from "react-toastify";
import { t } from "i18next";

export const fetchPromotionList = (id_promotion = 0) => {
  return (dispatch) => {
    return apiService
      .get(getPromotionList(id_promotion))
      .then((response) => {
        id_promotion == 0
          ? dispatch(promotionActions.fetchPromotionList(response.data))
          : dispatch(promotionActions.fetchPromotionDetail(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const createNewPromotion = (data, navigate) => {
  return async () => {
    try {
      const response = await apiService.postMultipart(
        pathCreatePromotion(),
        data
      );
      navigate("/promotion-list");
      toast.success(t("promotionsListActions.created"), {
        theme: "colored",
      });
    } catch (err) {
      handleError(err);
    }
  };
};

export const fetchImportPromotionProducts = (data) => {
  return async () => {
    try {
      const response = await apiService.postMultipart(
        postImportPromotion(),
        data
      );
      toast.success(t("promotionsListActions.importProducts"), {
        theme: "colored",
      });
      return response.data;
    } catch (err) {
      handleError(err);
      return null;
    }
  };
};

export const fetchClearDetailPromotion = () => {
  return (dispatch) => {
    dispatch(promotionActions.fetchPromotionClearDetail());
  };
};

export const createNewPromotion1 = (data, navigate) => {
  return (dispatch) => {
    return apiService
      .postMultipart(pathCreatePromotion(), data)
      .then((response) => {
        // dispatch(promotionActions.fetchPromotionList(response.data));
        toast.success(t("promotionsListActions.created"), {
          theme: "colored",
        });
        navigate("/promotion-list");
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchEditPromotion = (data, navigate) => {
  return (dispatch) => {
    return apiService
      .putMultipart(pathCreatePromotion(), data)
      .then((response) => {
        // dispatch(promotionActions.fetchPromotionList(response.data));
        toast.success(t("promotionsListActions.updated"), {
          theme: "colored",
        });
        navigate("/promotion-list");
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchDeletePromotion = (id) => {
  return (dispatch) => {
    return apiService
      .delete(pathDeletePromotion(id))
      .then((response) => {
        toast.success(t("promotionsListActions.deleted"), {
          theme: "colored",
        });

        dispatch(fetchPromotionList(0));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

const handleError = (err) => {
  let errorMessage = err.response ? err.response.data.message : err;
  if (!err.response) {
    toast.error(t("actions.error.refreshPage") + err.response, {
      theme: "colored",
    });
  }
  toast.error(errorMessage, { theme: "colored" });
};
